'use client';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';
import { faDownload, faFloppyDisks, faLockKeyhole } from '@fortawesome/pro-duotone-svg-icons';

export interface SubHeaderMobileMenuProps {
  isAuthenticated: boolean;
  searchExecutionId?: string;
  openCreateAgentModal: () => void;
  isAgentLimitReached: boolean;
  handleExportButtonClick: () => Promise<void>;
  hasPermissionToExport: boolean;
}

const SubHeaderMobileMenu: React.FC<SubHeaderMobileMenuProps> = ({
  isAuthenticated,
  searchExecutionId,
  openCreateAgentModal,
  isAgentLimitReached,
  handleExportButtonClick,
  hasPermissionToExport,
}) => {
  return (
    <>
      {searchExecutionId && (
        <div className="flex items-center xl:hidden">
          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="btn btn-ghost !h-8 !min-h-2">
              <FontAwesomeIcon icon={faEllipsisVertical} className="h-5 w-5 text-white" />
            </label>
            <ul tabIndex={0} className="menu dropdown-content w-3xs rounded-box bg-base-100 p-2 shadow">
              {isAuthenticated && (
                <li>
                  <button onClick={openCreateAgentModal} className="text-sm">
                    <span className="relative">
                      <FontAwesomeIcon icon={faFloppyDisks} className="h-4 w-4" />
                      {isAgentLimitReached && (
                        <FontAwesomeIcon
                          icon={faLockKeyhole}
                          className="fa-fw absolute -right-1.5 -top-1 h-3 w-3 text-accent"
                        />
                      )}
                    </span>
                    Als Suchprofil speichern
                  </button>
                </li>
              )}
              <li>
                <button onClick={handleExportButtonClick} className="text-sm">
                  <span className="relative">
                    <FontAwesomeIcon icon={faDownload} className="h-4 w-4" />
                    {!hasPermissionToExport && (
                      <FontAwesomeIcon
                        icon={faLockKeyhole}
                        className="fa-fw absolute -right-1.5 -top-1 h-3 w-3 text-accent"
                      />
                    )}
                  </span>
                  Suchergebnisse exportieren
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default SubHeaderMobileMenu;
